module.exports = __webpack_public_path__ + "static/media/logo_white.604137e0.svg";